import Yup from '@fourthwall/utils/dist/yup';
export const validationSchema = Yup.object().shape({
    // todo: fix this validation
    sendTo: Yup.object().required(),
    subject: Yup.string().trim().required(),
    message: Yup.string().trim().required(),
});
